import React, { FC } from 'react';
import {
  FeatureGroupModel,
  FeatureModel,
  MediaLinkModel,
} from '@vp/digital-common-data-model-lib';
import {
  PricingContextModel,
  usePricingContext,
} from '@vp/digital-pricing-lib';
import {
  Box,
  Column,
  Divider,
  FlexBox,
  GridContainer,
  H2,
  PipeSeparator,
  Row,
  Spinner,
  Typography,
  useScreenClass,
} from '@vp/swan';
import { Option, isNone } from 'fp-ts/lib/Option';
import Markdown from 'markdown-to-jsx';

import './PaymentsControlContainer.scss';

const PaymentsControlContainer: FC<{
  className?: string;
  component?: any;
  content: FeatureGroupModel;
  isPlanPage?: boolean;
}> = ({ content, isPlanPage = true }) => {
  const pricingContextOption: Option<PricingContextModel> = usePricingContext();
  const isMobile = useScreenClass() === 'xs';

  const vatIncludedDescription = () => {
    return (
      <>
        <Typography component="p" fontSize="xsmall" textColor="subtle">
          {!isNone(pricingContextOption) ? (
            pricingContextOption.value.isVatInclusive ? (
              content.title
            ) : (
              content.description
            )
          ) : (
            <Spinner size="tiny" accessibleText="Loading..." />
          )}
        </Typography>
        <Divider my={'5'} />
      </>
    );
  };

  const newContent: {
    feature?: FeatureModel;
    isDivider: boolean;
    props: {};
  }[] = [];
  content.features.forEach((feature: FeatureModel, index: number) => {
    if (index > 0) {
      newContent.push({
        isDivider: true,
        props: !isMobile
          ? { span: 1, textAlign: 'center' }
          : { span: 12, textAlign: 'center' },
      });
    }
    newContent.push({
      feature,
      isDivider: false,
      props: isMobile ? { span: 12, py: 5 } : { span: 3, py: 0 },
    });
  });
  return (
    <Box className="new-payments-methods__container">
      {isPlanPage && vatIncludedDescription()}
      <GridContainer>
        <Row>
          {newContent &&
            newContent.map((content: any, index: number) => (
              <Column key={index} {...content.props}>
                {content.isDivider &&
                  (!isMobile ? (
                    <PipeSeparator style={{ height: '100%' }} />
                  ) : (
                    <Divider />
                  ))}
                {!content.isDivider && content.feature && (
                  <>
                    <FlexBox gap={'3'}>
                      {content.feature?.key === 'titleWithIcon' &&
                        content.feature?.mediaUrl && (
                          <img
                            src={content.feature.mediaUrl}
                            alt={content.feature.altText}
                            height="24"
                            width="24"
                          />
                        )}
                      {content.feature?.title && (
                        <H2 fontSize="small">{content.feature.title}</H2>
                      )}
                    </FlexBox>
                    <FlexBox gap={'3'}>
                      {content.feature?.description && (
                        <Typography
                          component="p"
                          m={0}
                          fontSize="xsmall"
                          textColor="standard"
                        >
                          {typeof content.feature.description === 'string' ? (
                            <Markdown options={{ forceInline: true }}>
                              {content.feature.description}
                            </Markdown>
                          ) : (
                            content.feature.description
                          )}
                        </Typography>
                      )}
                      {content.feature?.key !== 'titleWithIcon' &&
                        (isMobile
                          ? content.feature.iconsMobile
                          : content.feature.icons
                        ).map((icon: MediaLinkModel) => (
                          <Box key={icon.secureUrl} mt={'3'} mr={'2'}>
                            <img src={icon.secureUrl} alt={icon.fileName} />
                          </Box>
                        ))}
                    </FlexBox>
                  </>
                )}
              </Column>
            ))}
        </Row>
      </GridContainer>
    </Box>
  );
};

export default PaymentsControlContainer;
